import { Button, TextField } from '@mui/material';
import Autocomplete, { AutocompleteRenderInputParams } from '@mui/material/Autocomplete';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import './AutoCompleteCardStyles.css';
import Popper from '@mui/material/Popper';

const CustomPopper = (props: any) => (
    <Popper {...props} style={{ width: 'auto', minWidth: props.anchorEl?.clientWidth }} placement="bottom-start" />
);

interface AutoCompleteCardProps {
    label: string;
    options: string[];
    value: string;
    noOptionsText: string;
    onSubmit: (value: string) => void;
    onInputChange: (event: React.SyntheticEvent, value: string, reason: string) => void;
}

const AutoCompleteCard: React.FC<AutoCompleteCardProps> = ({
    label,
    options,
    value,
    noOptionsText,
    onSubmit,
    onInputChange
}) => {
    return (
        <Card className="ac-container adaptive">
            <CardContent className="ac-content">
                <p className="ac-label adaptive">{label}</p>
                <Autocomplete
                    PopperComponent={CustomPopper}
                    value={value}
                    options={options}
                    noOptionsText={noOptionsText}
                    onInputChange={onInputChange}
                    onChange={(event, newValue) => {
                        if (newValue !== null) {
                            onInputChange(event, newValue, 'select-option');
                        }
                    }}
                    renderInput={(params: AutocompleteRenderInputParams) => (
                        <TextField
                            {...params}
                            className="ac-input adaptive"
                            variant="standard"
                            InputProps={{
                                ...params.InputProps,
                                disableUnderline: true,
                            }}
                        />
                    )}
                />
                <Button
                    className="ac-pushButton adaptive"
                    disableElevation
                    disableRipple
                    variant="text"
                    onClick={() => onSubmit(value)}
                >
                    Submit
                </Button>

            </CardContent>
        </Card>
    );
};

export default AutoCompleteCard;
